import {hoistCmp} from '@xh/hoist/core';
import {AddDistributionDialogModel} from './AddDistributionDialogModel';
import {dialog} from '@xh/hoist/kit/blueprint';
import {Icon} from '@xh/hoist/icon';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {grid} from '@xh/hoist/cmp/grid';
import {toolbar} from '@xh/hoist/desktop/cmp/toolbar';
import {button} from '@xh/hoist/desktop/cmp/button';
import {filler, hframe} from '@xh/hoist/cmp/layout';
import {form} from '@xh/hoist/cmp/form';
import {formField} from '@xh/hoist/desktop/cmp/form';
import {dateInput, numberInput, select} from '@xh/hoist/desktop/cmp/input';
import './Distributions.scss';
import {defaultRsOptions} from '../../../cmp/SelectOptions';

export const addDistributionDialog = hoistCmp.factory<AddDistributionDialogModel>(({model}) =>
    dialog({
        style: {width: 750, height: 'fit-content'},
        icon: Icon.dollarSignCircle(),
        title: 'Process Distribution',
        canOutsideClickClose: false,
        isOpen: model.isOpen,
        onClose: () => model.close(),
        item: panel({
            items: [distributionForm(), grid({minHeight: 50, agOptions: {domLayout: 'autoHeight'}, model: model.gridModel})],
            bbar: bbar(),
            mask: model.apiTask
        })
    })
);

const distributionForm = hoistCmp.factory<AddDistributionDialogModel>(({model}) => {
    return form({
        model: model.formModel,
        fieldDefaults: {commitOnChange: true, minimal: true},
        item: hframe(
            formField({
                field: 'securityId',
                label: 'Deal',
                width: 200,
                item: select({
                    className: 'distribution-security-select',
                    options: model.securitieOptions,
                    rsOptions: defaultRsOptions()
                })
            }),
            formField({
                field: 'amount',
                width: 100,
                item: numberInput({min: 1, precision: 2, leftIcon: Icon.dollarSign()})
            }),
            formField({
                field: 'posted',
                label: 'As of',
                width: 110,
                item: dateInput({valueType: 'localDate'})
            }),
            button({
                className: 'distribution-process-button',
                text: 'Calculate',
                icon: Icon.calculator(),
                minimal: false,
                intent: 'primary',
                disabled: !model.formModel.isValid,
                onClick: () => model.process()
            })
        )
    });
});

const bbar = hoistCmp.factory<AddDistributionDialogModel>(({model}) =>
    toolbar(
        filler(),
        button({
            text: 'Cancel',
            icon: Icon.cross(),
            onClick: () => model.close()
        }),
        button({
            text: 'Process',
            icon: Icon.check(),
            intent: 'success',
            disabled: !model.formModel.isValid,
            onClick: () => model.save()
        })
    )
);
